import { gql } from '@apollo/client';
import { VOLUNTEER_COMMUNICATION_EMAIL_FRAGMENT } from '../volunteer-common-profile/communications-model.gql';

export const GET_SENT_EMAIL = gql`
  query GetSentEmail($emailId: String!) {
    em {
      email(emailId: $emailId) {
        ...VolunteerCommonProfileEmail
      }
    }
  }
  ${VOLUNTEER_COMMUNICATION_EMAIL_FRAGMENT}
`;
